let $eventSliders;

$(document).ready(($) => {
  // Detect if device is mobile for native scroll behavior
  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
           (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform));
  }

  // Add mobile class to body for CSS styling
  const isMobile = isMobileDevice();
  if (isMobile) {
    $('body').addClass('is-mobile');
  }
  

  let resizeTimer;
  const sliderSpacing = 24;

  $eventSliders = $('.js-event-slider');

  function checkSliderStatus() {
    $eventSliders.each(function () {
      const $slider = $(this);
      const $sliderItems = $slider.find('.c-event-slider__items');
      const $sliderNext = $slider.find('.js-event-slider-next');
      const $sliderPrev = $slider.find('.js-event-slider-prev');
      const itemContainerWidth = $sliderItems.outerWidth();
      let itemsWidth = 0;

      $sliderItems.children().each(function () {
        itemsWidth += $(this).outerWidth(true);
      });

      if (itemsWidth > itemContainerWidth) {
        $slider.addClass('has-slider');

        const isAtBeginning = $sliderItems.scrollLeft() === 0;
        const endOfSlider = $sliderItems.scrollLeft() + $sliderItems.width();
        const isAtEnd = endOfSlider >= $sliderItems[0].scrollWidth - 1;

        $sliderNext?.prop('disabled', isAtEnd);
        $sliderPrev?.prop('disabled', isAtBeginning);
      } else {
        $slider.removeClass('has-slider');
        $sliderNext?.prop('disabled', true);
        $sliderPrev?.prop('disabled', true);
      }
    });
  }

  $(window).on('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkSliderStatus, 200);
  });

  checkSliderStatus();

  // Handle visual scrollbars and item dragging
  $eventSliders.each(function () {
    const $slider = $(this);
    const $itemContainer = $slider.find('.js-event-slider-items');
    const $scrollbar = $slider.find('.js-event-slider-scrollbar');
    const $scrollbarTrack = $scrollbar.find('.c-event-slider__scrollbar-track');
    const $scrollbarThumb = $scrollbar.find('.js-event-slider-thumb');

    let isDragging = false;
    let isItemDragging = false;
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let hasScrolled = false;
    let dragStartTime = 0;
    let dragDistance = 0;
    let clickedLink = null;

    function updateScrollbar() {
      const scrollWidth = $itemContainer[0].scrollWidth;
      const clientWidth = $itemContainer[0].clientWidth;
      const scrollLeft = $itemContainer[0].scrollLeft;

      const thumbWidth = Math.max((clientWidth / scrollWidth) * 100, 5); // %
      const thumbPosition = (scrollLeft / (scrollWidth - clientWidth)) * (100 - thumbWidth);

      $scrollbarThumb.css({
        width: `${thumbWidth}%`,
        left: `${thumbPosition}%`
      });

      if (scrollWidth > 1024) {
        $scrollbar.show();
      } else {
        $scrollbar.hide();
      }

    }

    function beginDrag(e) {
      e.preventDefault();
      isDragging = true;
      startX = e.pageX;
      startScrollLeft = $itemContainer[0].scrollLeft;
      $('body').addClass('dragging');

      $(document).on('mousemove.thumb', drag);
      $(document).on('mouseup.thumb', endDrag);
    }

    function beginItemDrag(e) {
      // Always prevent default to stop immediate link navigation
      
      if (!isMobile) {
        e.preventDefault();
      }
      
      isItemDragging = true;
      hasScrolled = false;
      dragDistance = 0;
      dragStartTime = Date.now();
      startX = e.pageX;
      startY = e.pageY;
      startScrollLeft = $itemContainer[0].scrollLeft;
      
      // Store the clicked link for potential navigation later
      clickedLink = $(e.target).closest('a')[0];

      $(document).on('mousemove.items', dragItems);
      $(document).on('mouseup.items', endItemDrag);
    }

    function drag(e) {
      if (!isDragging) return;
      const currentX = e.pageX;
      const deltaX = currentX - startX;
      const scrollRatio = $itemContainer[0].scrollWidth / $scrollbarTrack.width();

      $itemContainer[0].scrollLeft = startScrollLeft + deltaX * scrollRatio;
    }

    function dragItems(e) {
      if (!isItemDragging) return;
      
      const currentX = e.pageX;
      const currentY = e.pageY;
      const deltaX = currentX - startX;
      const deltaY = currentY - startY;
      
      // Calculate total distance moved
      dragDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
      
      // If we've moved more than 10px or it's been more than 200ms, consider it a drag
      const dragThreshold = 10;
      const timeThreshold = 200;
      const timeElapsed = Date.now() - dragStartTime;
      
      if (dragDistance > dragThreshold || timeElapsed > timeThreshold) {
        hasScrolled = true;
        
        // Only prevent default and add classes when we're actually dragging
        if (!$('body').hasClass('dragging')) {
          e.preventDefault();
          $('body').addClass('dragging');
          $itemContainer.addClass('is-dragging');
        }
        
        $itemContainer[0].scrollLeft = startScrollLeft - deltaX;
      }
    }

    function endDrag() {
      isDragging = false;
      $('body').removeClass('dragging');
      $(document).off('.thumb');
    }

    function endItemDrag() {
      const wasActualDrag = hasScrolled;
      
      isItemDragging = false;
      $('body').removeClass('dragging');
      $itemContainer.removeClass('is-dragging');
      $(document).off('.items');
      
      // If it wasn't actually a drag, navigate to the link
      if (!wasActualDrag && clickedLink && clickedLink.href) {
        // Small delay to ensure all events are processed
        setTimeout(() => {
          window.location.href = clickedLink.href;
        }, 10);
      }
      
      // Reset variables
      setTimeout(() => {
        hasScrolled = false;
        dragDistance = 0;
        clickedLink = null;
      }, wasActualDrag ? 100 : 50);
    }

    // Init - Always update scrollbar for visual feedback
    updateScrollbar();

    $itemContainer.on('scroll', updateScrollbar);
    $(window).on('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        updateScrollbar();
      }, 200);
    });

    // Only add drag functionality on desktop
    if (!isMobile) {
      // Event listeners for scrollbar thumb dragging
      $scrollbarThumb.on('mousedown', beginDrag);
      
      // Event listeners for item container dragging
      $itemContainer.on('mousedown', function(e) {
        if (e.button === 0) {
          // Left click - start drag detection
          beginItemDrag(e);
        } else {
          // Right/middle click - ensure clean state
          isItemDragging = false;
          hasScrolled = false;
          clickedLink = null;
          $('body').removeClass('dragging');
          $itemContainer.removeClass('is-dragging');
          $(document).off('.items');
        }
      });
      
      // Prevent clicks only during our managed drag/click interactions
      $itemContainer.on('click', function(e) {
        // Only prevent clicks if we have an active drag state or stored link
        // This is only set during left-click interactions
        if (hasScrolled || isItemDragging || clickedLink) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
      
      // Prevent text selection during drag
      $itemContainer.on('selectstart', function(e) {
        if (isItemDragging) {
          e.preventDefault();
        }
      });
      
      // Prevent default image dragging
      $itemContainer.on('dragstart', 'img', function(e) {
        e.preventDefault();
        return false;
      });
      
      // Only prevent context menu during active drag operations
      $itemContainer.on('contextmenu', function(e) {
        if (isItemDragging) {
          e.preventDefault();
          return false;
        }
        // Allow normal right-click context menu when not dragging
      });
    }
  });
});